import { Box } from '@mui/material';
import * as React from 'react';

import { useManageWorkspaceControls } from '~/scenes/MyWorkspace/components/ManageWorkspaceControls/useManageWorkspaceControls';
import { WorkspaceToolbarEditMode } from '~/scenes/MyWorkspace/components/WorkspaceToolbar/components/WorkspaceToolbarEditMode';
import { WorkspaceToolbarReadMode } from '~/scenes/MyWorkspace/components/WorkspaceToolbar/components/WorkspaceToolbarReadMode';

import { sxStyles } from './useStyles';

export const WorkspaceToolbar = () => {
  const { inEditMode } = useManageWorkspaceControls();

  return (
    <Box sx={sxStyles.root}>
      {inEditMode ? <WorkspaceToolbarEditMode /> : <WorkspaceToolbarReadMode />}
    </Box>
  );
};
